export default __webpack_public_path__ + "static/media/handshake.7c7f6f66.png";